import React from "react";
import Modal from "react-modal";

import { getModalCustomStyles } from "../../utils/constants/constants";
import Button from "../Button/Button";
import "./ConfirmationModal.scss";
import SecondaryButton from "../SecondaryButton/SecondaryButton";

const ConfirmationModal = ({
  showModal = true,
  setShowModal = () => {},
  question,
  actionName,
  onSuccess = () => {},
}) => {
  return showModal ? (
    <Modal
      isOpen={showModal}
      style={getModalCustomStyles(200, { width: 450 })}
      ariaHideApp={false}
    >
      <div className="confirmation-modal__wrapper">
        <span className="confirmation-modal__title">Are you sure?</span>
        <span className="confirmation-modal__subtitle">{question}</span>
        <div className="confirmation-modal__buttons">
          <SecondaryButton
            title="No"
            wrapperClass="confirmation-modal__button"
            onClick={() => setShowModal(false)}
            labelClass="confirmation-modal__label-no"
          />
          <Button
            wrapperStyles="confirmation-modal__button confirmation-modal__button-yes"
            labelStyles="confirmation-modal__label-yes"
            label={actionName ? `Yes, ${actionName}` : "Yes"}
            onPress={onSuccess}
          />
        </div>
      </div>
    </Modal>
  ) : null;
};

export default ConfirmationModal;
